import { classNames } from '@common/application/utils/classnames';
import type { CSSProperties } from 'react';

export const LeftArrowLine = (props: { style?: CSSProperties; className?: string }) => {
  return (
    <span className={classNames('w-6 h-6 inline-block', props.className)}>
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        fill="currentColor"
      >
        <path d="M768.5613037 923.42044445L355.07768889 509.81546667 768.19721482 95.72503703c17.71899259-17.71899259 17.71899259-46.72474075 0-64.44373333-17.71899259-17.71899259-46.60337778-17.71899259-64.32237037 0L262.9632 473.16385185c-1.69908148 1.21362963-3.2768 2.66998518-4.73315555 4.12634074-8.98085925 8.98085925-13.34992592 20.75306667-13.22856297 32.52527408-0.12136297 11.77220741 4.36906667 23.66577778 13.22856297 32.52527408 1.69908148 1.69908148 3.39816297 3.15543703 5.2186074 4.49042962L704.23893333 987.74281482c17.71899259 17.71899259 46.60337778 17.71899259 64.32237037 0 17.71899259-17.59762963 17.71899259-46.60337778 0-64.32237037z"></path>
      </svg>
    </span>
  );
};
